import { combineReducers, Reducer } from 'redux';
import authReducer from './AuthReducer';
import projectReducer from './ProjectReducer';
import resultReducer from './ResultReducer';

const rootReducer = combineReducers({
  auth: authReducer as Reducer<Partial<{ isAuthenticated: boolean; token: any; profile: any; forgotPassword: any }>>,
  projectData: projectReducer as Reducer<Partial<{ projects: any[]; project: any; loading: boolean; error: any }>>,
  resultData: resultReducer as Reducer<Partial<{ qcDurations: Record<string, number>; loading: boolean; error: any }>>,
});

export default rootReducer;